<template>
  <router-link
    class="product-link"
    :to="{ 
      name: 'supplier', 
      params: { supplierId: supplier.id } 
    }">
    <div class="supplier-card card">
      <div class="card-body">
        <div class="card-title card-name">{{ supplier.name }}</div>
        <br />
        <!-- <div class="trashIcon" @click="deleteSupplier">
          <font-awesome-icon class="icon" icon="trash" />
        </div> -->
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  data() {
    return {
      id: this.supplier.id
    }
  },
  methods: {
    deleteSupplier(event) {
      event.preventDefault()
      if (confirm('are you sure?')) {
        this.$store
          .dispatch('supplier/removeSupplier', this.id)
          .then(() => {
            this.$store.dispatch('supplier/fetchSuppliers')
          })
          .catch(e => console.log(e))
      }
    }
  },
  props: {
    supplier: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style scoped>
.supplier-card {
  width: 15rem;
  color: #454655;
  margin: auto 10px;
  padding: 20px;
  border-radius: 5px;
}
.card-body {
  position: relative;
  padding: 0; 
}
.card-title {
  margin-bottom: 0;
  font-size: 1.2rem;
  text-align: left;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: absolute;
  top: 0%;
}

@media screen and (max-width: 780px){
  .supplier-card {
  width: 90%;
  }
}

.product-card:hover {
  background: rgba(128, 128, 128, 0.315);
  color: var(--primary);
  padding: 20px;
  border-radius: 5px;
}
.product-card:active {
  background: #707181;
  padding: 20px;
  border-radius: 5px;
}
.right {
  position: relative;
  float: right;
}
.trashIcon {
  background: var(--primary);
  color: var(--bright);
  padding: 0.3em;
  position: absolute;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 40px;
  height: 40px;
  right: 5px;
  top: -40%;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}

</style>
